export function ReadmePage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b border-gray-200 bg-white sticky top-0 z-10">
        <div className="max-w-5xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <svg
                width="100"
                height="23"
                viewBox="0 0 149 28"
                fill="currentColor"
                className="text-black"
              >
                <g clipPath="url(#clip0_1924_2917)">
                  <path
                    d="M27.0229 27.8718C26.8948 27.8718 26.7642 27.8417 26.6461 27.7839L13.9359 21.4841L1.2258 27.7839C0.962053 27.9145 0.650579 27.8995 0.401902 27.7437C0.153225 27.588 0 27.3167 0 27.0228V0.848971C0 0.55508 0.153225 0.281285 0.401902 0.125548C0.653091 -0.0276774 0.967076 -0.0427487 1.22831 0.0903812L13.9359 6.48062L26.6436 0.0903812C26.9073 -0.0427487 27.2188 -0.0276774 27.47 0.125548C27.7212 0.278773 27.8719 0.552568 27.8719 0.846459V27.0228C27.8719 27.3167 27.7212 27.588 27.47 27.7437C27.3344 27.8291 27.1786 27.8718 27.0229 27.8718ZM15.845 20.5371L26.1739 25.6564V15.4154L15.845 20.5346V20.5371ZM1.69552 15.4179V25.6589L12.0244 20.5396L1.69552 15.4179ZM2.71033 14.0263L13.9359 19.5902L25.1616 14.0263L13.9359 8.37961L2.71033 14.0263ZM15.8249 7.43011L26.1764 12.6373V2.22548L15.8249 7.43262V7.43011ZM1.69552 2.22548V12.6373L12.047 7.43011L1.69552 2.22548Z"
                    fill="currentColor"
                  />
                  <path
                    d="M41.8984 0.562683H49.4818L56.8743 22.283L64.3421 0.562683H71.6969V27.4273H67.0098L67.163 4.63947L59.2757 27.4273H54.3222L46.4349 4.63947L46.5505 27.4273H41.9009V0.562683H41.8984ZM74.5278 17.8997C74.5278 11.9541 78.9111 7.8773 84.9296 7.8773C90.948 7.8773 95.3313 11.9541 95.3313 17.8997C95.3313 23.8454 90.9882 27.9975 84.9296 27.9975C78.8709 27.9975 74.5278 23.9207 74.5278 17.8997ZM84.9296 24.3779C88.4362 24.3779 90.6466 21.6726 90.6466 17.8997C90.6466 14.1269 88.4738 11.4969 84.9698 11.4969C81.4657 11.4969 79.215 14.049 79.215 17.8997C79.215 21.7504 81.4632 24.3779 84.9321 24.3779H84.9296ZM98.0466 8.45001H102.505V10.9644C103.191 9.8215 105.173 7.8773 108.526 7.8773C112.603 7.8773 115.652 10.354 115.652 15.2321V27.4248H111.081V15.84C111.081 12.7152 109.556 11.5723 107.155 11.5723C103.917 11.5723 102.658 14.0867 102.658 17.4777V27.4223H98.0466V8.45001ZM120.224 21.4063V11.7657H116.986V8.45001H120.224V3.64979H124.796V8.45001H129.063V11.7657H124.796V21.331C124.796 23.1596 125.672 23.7323 127.272 23.7323H129.063V27.4298H125.901C122.244 27.4298 120.224 25.2947 120.224 21.4088V21.4063ZM130.809 22.2453C130.809 19.54 132.218 17.7867 134.848 16.797C136.755 16.1113 139.191 15.8827 142.469 15.8827H144.185V15.1593C144.185 13.3306 143.346 11.2332 139.842 11.2332C137.099 11.2332 135.765 12.7202 135.65 14.471H131.266C131.533 10.6605 134.924 7.87981 139.917 7.87981C145.594 7.87981 148.644 10.8137 148.644 15.6918V27.4273H144.338V24.9506C143.499 26.1312 141.633 28 137.441 28C133.248 28 130.809 25.7519 130.809 22.2453ZM138.815 24.722C142.243 24.722 144.341 22.6648 144.341 19.5777V18.8166H142.703C140.035 18.8166 138.32 18.9698 137.177 19.427C135.881 19.9595 135.424 20.8361 135.424 22.0569C135.424 23.5037 136.491 24.7245 138.815 24.7245V24.722Z"
                    fill="currentColor"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1924_2917">
                    <rect width="148.641" height="28" fill="currentColor" />
                  </clipPath>
                </defs>
              </svg>
              <span className="text-gray-400">|</span>
              <h1 className="text-xl font-semibold text-gray-900">Web Map</h1>
            </div>
            <a
              href="/"
              className="text-sm text-gray-600 hover:text-gray-900 transition-colors"
            >
              ← Back to Map
            </a>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-5xl mx-auto px-6 py-12">
        {/* Quick Summary */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            About Monta Web Map
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed mb-4">
            The Monta Web Map is an interactive web application that displays
            all charge points available through Monta&apos;s platform. Built
            with modern web technologies, it provides a seamless experience for
            finding, filtering, and viewing detailed information about EV
            charging stations worldwide.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed mb-4">
            Whether you&apos;re planning your next EV road trip, looking for
            nearby charging options, or managing a fleet of electric vehicles,
            our map gives you instant access to real-time availability, dynamic
            pricing, and comprehensive station details across multiple countries
            and languages.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            With advanced filtering by speed, price, operator, and availability,
            plus white-label capabilities for our partners, the Monta Web Map is
            designed to make EV charging more accessible and transparent for
            everyone. Access it from any device with a web browser—no app
            installation required.
          </p>
        </section>

        {/* Features */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-8">
            Key Features
          </h2>

          <div className="space-y-8">
            {/* Interactive Map */}
            <div className="border border-gray-200 rounded-lg p-6">
              <div className="flex items-start gap-3 mb-3">
                <svg
                  className="w-6 h-6 text-blue-600 mt-0.5 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
                  />
                </svg>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    Interactive Map
                  </h3>
                  <p className="text-gray-700 mb-3">
                    Powered by Google Maps with intelligent marker visualization
                    and smooth navigation.
                  </p>
                  <ul className="space-y-2 text-sm text-gray-600">
                    <li className="flex items-start gap-2">
                      <span className="text-blue-600 mt-1">•</span>
                      <span>
                        <strong>Smart Markers:</strong> Color-coded by
                        availability status (green=available, orange=busy,
                        gray=passive, red=error)
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-blue-600 mt-1">•</span>
                      <span>
                        <strong>Cluster View:</strong> Automatic grouping of
                        nearby charge points at lower zoom levels
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-blue-600 mt-1">•</span>
                      <span>
                        <strong>Responsive Zoom:</strong> Zoom levels from 5
                        (country view) to 17 (street view)
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-blue-600 mt-1">•</span>
                      <span>
                        <strong>Deep Linking:</strong> Share specific locations,
                        charge points, or filtered views via URL
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Charge Point Discovery */}
            <div className="border border-gray-200 rounded-lg p-6">
              <div className="flex items-start gap-3 mb-3">
                <svg
                  className="w-6 h-6 text-green-600 mt-0.5 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    Charge Point Discovery
                  </h3>
                  <p className="text-gray-700 mb-3">
                    Find charge points quickly with advanced search and
                    filtering capabilities.
                  </p>
                  <ul className="space-y-2 text-sm text-gray-600">
                    <li className="flex items-start gap-2">
                      <span className="text-green-600 mt-1">•</span>
                      <span>
                        <strong>Location Search:</strong> Typeahead search with
                        geocoding API for addresses and places
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-green-600 mt-1">•</span>
                      <span>
                        <strong>Real-Time Filtering:</strong> Instant updates
                        with 700ms debounce for smooth performance
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-green-600 mt-1">•</span>
                      <span>
                        <strong>Browser Geolocation:</strong> Find charge points
                        near your current location
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-green-600 mt-1">•</span>
                      <span>
                        <strong>Search Area Refresh:</strong> Update results for
                        current map viewport
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Advanced Filtering */}
            <div className="border border-gray-200 rounded-lg p-6">
              <div className="flex items-start gap-3 mb-3">
                <svg
                  className="w-6 h-6 text-purple-600 mt-0.5 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
                  />
                </svg>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    Advanced Filtering
                  </h3>
                  <p className="text-gray-700 mb-3">
                    Narrow down results with multiple filter options that sync
                    with URL parameters.
                  </p>
                  <ul className="space-y-2 text-sm text-gray-600">
                    <li className="flex items-start gap-2">
                      <span className="text-purple-600 mt-1">•</span>
                      <span>
                        <strong>Availability:</strong> Filter by Available,
                        Busy, Queue, or Passive status
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-purple-600 mt-1">•</span>
                      <span>
                        <strong>Charge Speed:</strong> Slow (0-22kW), Fast
                        (23-99kW), or Ultra-Fast (100+kW)
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-purple-600 mt-1">•</span>
                      <span>
                        <strong>Price Filter:</strong> Set maximum price per kWh
                        in local currency
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-purple-600 mt-1">•</span>
                      <span>
                        <strong>Stability Score:</strong> Filter by reliability
                        score (0-100)
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-purple-600 mt-1">•</span>
                      <span>
                        <strong>Operator Selection:</strong> Filter by specific
                        charging network operators
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-purple-600 mt-1">•</span>
                      <span>
                        <strong>Auto-Charge:</strong> Show only charge points
                        with auto-charge capability
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Charge Point Details */}
            <div className="border border-gray-200 rounded-lg p-6">
              <div className="flex items-start gap-3 mb-3">
                <svg
                  className="w-6 h-6 text-orange-600 mt-0.5 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    Detailed Charge Point Information
                  </h3>
                  <p className="text-gray-700 mb-3">
                    Comprehensive details for every charge point, displayed in a
                    responsive panel.
                  </p>
                  <ul className="space-y-2 text-sm text-gray-600">
                    <li className="flex items-start gap-2">
                      <span className="text-orange-600 mt-1">•</span>
                      <span>
                        <strong>Location Details:</strong> Full address,
                        coordinates, and map view
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-orange-600 mt-1">•</span>
                      <span>
                        <strong>Real-Time Status:</strong> Current availability
                        with color-coded badges
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-orange-600 mt-1">•</span>
                      <span>
                        <strong>Connector Information:</strong> Types (CCS, Type
                        2, CHAdeMO), power output, quantity
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-orange-600 mt-1">•</span>
                      <span>
                        <strong>Pricing:</strong> Static rates and 24-hour
                        dynamic price forecast with charts
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-orange-600 mt-1">•</span>
                      <span>
                        <strong>Additional Fees:</strong> Starting fees,
                        charging fees, idle fees with smart labeling
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-orange-600 mt-1">•</span>
                      <span>
                        <strong>Stability Score:</strong> Reliability rating
                        with visual indicator
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-orange-600 mt-1">•</span>
                      <span>
                        <strong>Directions:</strong> Open in Google Maps, Apple
                        Maps, or Waze
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-orange-600 mt-1">•</span>
                      <span>
                        <strong>Share Options:</strong> Copy link, share via
                        social media
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-orange-600 mt-1">•</span>
                      <span>
                        <strong>App Download:</strong> Call-to-action to
                        download Monta mobile app
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Responsive Design */}
            <div className="border border-gray-200 rounded-lg p-6">
              <div className="flex items-start gap-3 mb-3">
                <svg
                  className="w-6 h-6 text-indigo-600 mt-0.5 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
                  />
                </svg>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    Responsive Design
                  </h3>
                  <p className="text-gray-700 mb-3">
                    Seamless experience across all devices with adaptive
                    layouts.
                  </p>
                  <ul className="space-y-2 text-sm text-gray-600">
                    <li className="flex items-start gap-2">
                      <span className="text-indigo-600 mt-1">•</span>
                      <span>
                        <strong>Mobile (&lt;800px):</strong> Bottom sheet
                        panels, single panel at a time, optimized touch controls
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-indigo-600 mt-1">•</span>
                      <span>
                        <strong>Desktop (≥800px):</strong> Side panels for
                        filters and details, both can be open simultaneously
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-indigo-600 mt-1">•</span>
                      <span>
                        <strong>Adaptive Viewport:</strong> Smooth transitions
                        when resizing browser
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Internationalization */}
            <div className="border border-gray-200 rounded-lg p-6">
              <div className="flex items-start gap-3 mb-3">
                <svg
                  className="w-6 h-6 text-teal-600 mt-0.5 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
                  />
                </svg>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    Multi-Language Support
                  </h3>
                  <p className="text-gray-700 mb-3">
                    Available in 6 languages with locale-specific formatting.
                  </p>
                  <ul className="space-y-2 text-sm text-gray-600">
                    <li className="flex items-start gap-2">
                      <span className="text-teal-600 mt-1">•</span>
                      <span>
                        <strong>Supported Languages:</strong> English (en,
                        en-US), Danish (da), Spanish (es), French (fr), German
                        (de)
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-teal-600 mt-1">•</span>
                      <span>
                        <strong>Auto-Detection:</strong> Automatically detects
                        browser language preference
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-teal-600 mt-1">•</span>
                      <span>
                        <strong>URL Override:</strong> Force specific language
                        with ?locale= parameter
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-teal-600 mt-1">•</span>
                      <span>
                        <strong>Locale Formatting:</strong> Dates, numbers, and
                        currency adapted to selected language
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* White-Label Support */}
            <div className="border border-gray-200 rounded-lg p-6">
              <div className="flex items-start gap-3 mb-3">
                <svg
                  className="w-6 h-6 text-pink-600 mt-0.5 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"
                  />
                </svg>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    White-Label & Branding
                  </h3>
                  <p className="text-gray-700 mb-3">
                    Customizable branding for partner charging operators.
                  </p>
                  <ul className="space-y-2 text-sm text-gray-600">
                    <li className="flex items-start gap-2">
                      <span className="text-pink-600 mt-1">•</span>
                      <span>
                        <strong>Operator Themes:</strong> Custom logos, colors,
                        and branding via ?operator= parameter
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-pink-600 mt-1">•</span>
                      <span>
                        <strong>Dynamic Theming:</strong> Color schemes and
                        branding load automatically from API
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-pink-600 mt-1">•</span>
                      <span>
                        <strong>Operator Filtering:</strong> Combine branding
                        with operator-specific charge point filtering
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-pink-600 mt-1">•</span>
                      <span>
                        <strong>Embed Ready:</strong> Hide UI controls for clean
                        iframe embedding with ?controls=false
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Additional Links */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">
            Related Resources
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <a
              href="/docs"
              className="p-5 border border-gray-200 rounded-lg hover:border-blue-400 hover:bg-blue-50 transition-all"
            >
              <h3 className="font-semibold text-gray-900 mb-2">
                URL Parameters Documentation
              </h3>
              <p className="text-sm text-gray-600">
                Learn about all available URL parameters for deep linking and
                custom configurations.
              </p>
            </a>
            <a
              href="https://monta.com"
              target="_blank"
              rel="noopener noreferrer"
              className="p-5 border border-gray-200 rounded-lg hover:border-blue-400 hover:bg-blue-50 transition-all"
            >
              <h3 className="font-semibold text-gray-900 mb-2">
                Monta Website
              </h3>
              <p className="text-sm text-gray-600">
                Visit the main Monta website to learn more about our EV charging
                platform and services.
              </p>
            </a>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200 mt-16">
        <div className="max-w-5xl mx-auto px-6 py-8">
          <p className="text-sm text-gray-600 text-center">
            © {new Date().getFullYear()} Monta. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
